import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore'
import { ArticleDraftDetail } from 'web_core/assets/draft/Article/Detail'
import { ArticleDraftPublicationForm } from 'web_core/assets/draft/Article/PublicationForm'
import { articleDraftRef } from 'web_core/firebase'
import { useRequireSignedIn } from 'web_core/firebase/hooks/useRequireSignedIn'
import { useMedia, useQueryData } from 'web_core/hooks'
import { isBlank } from 'web_core/utils'
import { getDefaultStaticPaths } from 'web_core/utils/static_paths'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

export const getStaticPaths = getDefaultStaticPaths

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const { user } = useRequireSignedIn()

  const router = useRouter()
  const id = useQueryData()
  const ref =
    !isBlank(id) && id !== '' && user ? articleDraftRef(user.uid, id) : null
  const [articleDraft, loading] = useDocumentDataOnce(ref)
  useEffect(() => {
    if (ref && !loading && !articleDraft) void router.push('/article_drafts')
  }, [loading])

  const isLg = useMedia('lg', true)

  return (
    <DefaultLayout
      head={{
        title: '記事の投稿',
        index: false,
      }}
      overflow={{ pc: false, sp: false }}
    >
      {articleDraft && (
        <div className="row gap-7 h-100">
          <div className="col h-100 d-flex flex-column">
            <h1 className="h4 flex-shrink-0 mb-4">記事の情報を入力</h1>
            <div className="flex-grow-1">
              <ArticleDraftPublicationForm draft={articleDraft} />
            </div>
          </div>
          {isLg && (
            <ArticleDraftDetail
              draft={articleDraft}
              className="col h-100 overflow-hidden"
            />
          )}
        </div>
      )}
    </DefaultLayout>
  )
}

export default Page
